import React from 'react'
import { useState } from 'react'
import { createPortal } from 'react-dom'
import { RadioGroup } from '@headlessui/react'
import './color-picker-popup-for-calendar.css'

const colors = [
  {name: 'Red', bgColor200: 'bg-red-200', bgColor500: 'bg-red-500', bgColor800: 'bg-red-800', textColor200: 'text-red-200', textColor500: 'text-red-500', textColor800: 'text-red-800', borderColor200: 'border-red-200', borderColor500: 'border-red-500', borderColor800: 'border-red-800', selectedColor: 'ring-red-200'},
  {name: 'Pink', bgColor200: 'bg-pink-200', bgColor500: 'bg-pink-500', bgColor800: 'bg-pink-800', textColor200: 'text-pink-200', textColor500: 'text-pink-500', textColor800: 'text-pink-800', borderColor200: 'border-pink-200', borderColor500: 'border-pink-500', borderColor800: 'border-pink-800', selectedColor: 'ring-pink-200'},
  {name: 'Purple', bgColor200: 'bg-purple-200', bgColor500: 'bg-purple-500', bgColor800: 'bg-purple-800', textColor200: 'text-purple-200', textColor500: 'text-purple-500', textColor800: 'text-purple-800', borderColor200: 'border-purple-200', borderColor500: 'border-purple-500', borderColor800: 'border-purple-800', selectedColor: 'ring-purple-200'},
  {name: 'Violet', bgColor200: 'bg-violet-200', bgColor500: 'bg-violet-500', bgColor800: 'bg-violet-800', textColor200: 'text-violet-200', textColor500: 'text-violet-500', textColor800: 'text-violet-800', borderColor200: 'border-violet-200', borderColor500: 'border-violet-500', borderColor800: 'border-violet-800', selectedColor: 'ring-violet-200'},
  {name: 'Indigo', bgColor200: 'bg-indigo-200', bgColor500: 'bg-indigo-500', bgColor800: 'bg-indigo-800', textColor200: 'text-indigo-200', textColor500: 'text-indigo-500', textColor800: 'text-indigo-800', borderColor200: 'border-indigo-200', borderColor500: 'border-indigo-500', borderColor800: 'border-indigo-800', selectedColor: 'ring-indigo-200'},
  {name: 'Blue', bgColor200: 'bg-blue-200', bgColor500: 'bg-blue-500', bgColor800: 'bg-blue-800', textColor200: 'text-blue-200', textColor500: 'text-blue-500', textColor800: 'text-blue-800', borderColor200: 'border-blue-200', borderColor500: 'border-blue-500', borderColor800: 'border-blue-800', selectedColor: 'ring-blue-200'},
  {name: 'Sky', bgColor200: 'bg-sky-200', bgColor500: 'bg-sky-500', bgColor800: 'bg-sky-800', textColor200: 'text-sky-200', textColor500: 'text-sky-500', textColor800: 'text-sky-800', borderColor200: 'border-sky-200', borderColor500: 'border-sky-500', borderColor800: 'border-sky-800', selectedColor: 'ring-sky-200'},
  {name: 'Cyan', bgColor200: 'bg-cyan-200', bgColor500: 'bg-cyan-500', bgColor800: 'bg-cyan-800', textColor200: 'text-cyan-200', textColor500: 'text-cyan-500', textColor800: 'text-cyan-800', borderColor200: 'border-cyan-200', borderColor500: 'border-cyan-500', borderColor800: 'border-cyan-800', selectedColor: 'ring-cyan-200'},
  {name: 'Teal', bgColor200: 'bg-teal-200', bgColor500: 'bg-teal-500', bgColor800: 'bg-teal-800', textColor200: 'text-teal-200', textColor500: 'text-teal-500', textColor800: 'text-teal-800', borderColor200: 'border-teal-200', borderColor500: 'border-teal-500', borderColor800: 'border-teal-800', selectedColor: 'ring-teal-200'},
  {name: 'Green', bgColor200: 'bg-green-200', bgColor500: 'bg-green-500', bgColor800: 'bg-green-800', textColor200: 'text-green-200', textColor500: 'text-green-500', textColor800: 'text-green-800', borderColor200: 'border-green-200', borderColor500: 'border-green-500', borderColor800: 'border-green-800', selectedColor: 'ring-green-200'},
  {name: 'Emerald', bgColor200: 'bg-emerald-200', bgColor500: 'bg-emerald-500', bgColor800: 'bg-emerald-800', textColor200: 'text-emerald-200', textColor500: 'text-emerald-500', textColor800: 'text-emerald-800', borderColor200: 'border-emerald-200', borderColor500: 'border-emerald-500', borderColor800: 'border-emerald-800', selectedColor: 'ring-emerald-200'},
  {name: 'Lime', bgColor200: 'bg-lime-200', bgColor500: 'bg-lime-500', bgColor800: 'bg-lime-800', textColor200: 'text-lime-200', textColor500: 'text-lime-500', textColor800: 'text-lime-800', borderColor200: 'border-lime-200', borderColor500: 'border-lime-500', borderColor800: 'border-lime-800', selectedColor: 'ring-lime-200'},
  {name: 'Yellow', bgColor200: 'bg-yellow-200', bgColor500: 'bg-yellow-500', bgColor800: 'bg-yellow-800', textColor200: 'text-yellow-200', textColor500: 'text-yellow-500', textColor800: 'text-yellow-800', borderColor200: 'border-yellow-200', borderColor500: 'border-yellow-500', borderColor800: 'border-yellow-800', selectedColor: 'ring-yellow-200'},
  {name: 'Amber', bgColor200: 'bg-amber-200', bgColor500: 'bg-amber-500', bgColor800: 'bg-amber-800', textColor200: 'text-amber-200', textColor500: 'text-amber-500', textColor800: 'text-amber-800', borderColor200: 'border-amber-200', borderColor500: 'border-amber-500', borderColor800: 'border-amber-800', selectedColor: 'ring-amber-200'},
  {name: 'Orange', bgColor200: 'bg-orange-200', bgColor500: 'bg-orange-500', bgColor800: 'bg-orange-800', textColor200: 'text-orange-200', textColor500: 'text-orange-500', textColor800: 'text-orange-800', borderColor200: 'border-orange-200', borderColor500: 'border-orange-500', borderColor800: 'border-orange-800', selectedColor: 'ring-orange-200'},
  {name: 'Rose', bgColor200: 'bg-rose-200', bgColor500: 'bg-rose-500', bgColor800: 'bg-rose-800', textColor200: 'text-rose-200', textColor500: 'text-rose-500', textColor800: 'text-rose-800', borderColor200: 'border-rose-200', borderColor500: 'border-rose-500', borderColor800: 'border-rose-800', selectedColor: 'ring-rose-200'},
  {name: 'Slate', bgColor200: 'bg-slate-200', bgColor500: 'bg-slate-500', bgColor800: 'bg-slate-800', textColor200: 'text-slate-200', textColor500: 'text-slate-500', textColor800: 'text-slate-800', borderColor200: 'border-slate-200', borderColor500: 'border-slate-500', borderColor800: 'border-slate-800', selectedColor: 'ring-slate-200'},
  {name: 'Gray', bgColor200: 'bg-gray-200', bgColor500: 'bg-gray-500', bgColor800: 'bg-gray-800', textColor200: 'text-gray-200', textColor500: 'text-gray-500', textColor800: 'text-gray-800', borderColor200: 'border-gray-200', borderColor500: 'border-gray-500', borderColor800: 'border-gray-800', selectedColor: 'ring-gray-200'},
  {name: 'Fuchsia', bgColor200: 'bg-fuchsia-200', bgColor500: 'bg-fuchsia-500', bgColor800: 'bg-fuchsia-800', textColor200: 'text-fuchsia-200', textColor500: 'text-fuchsia-500', textColor800: 'text-fuchsia-800', borderColor200: 'border-fuchsia-200', borderColor500: 'border-fuchsia-500', borderColor800: 'border-fuchsia-800', selectedColor: 'ring-fuchsia-200'}
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const ColorPickerPopupForCalendar = (props) => {
  const [selectedColor, setSelectedColor] = useState(props.teachObj.color)
  const modalRef = React.useRef(null)
  const [popupPosition, setPopupPosition] = React.useState({ top: 120, left: 120 })

  React.useEffect(() => {
    const anchorElement = document.getElementById(`teacher-calendar-${props.teachObj.TeacherID}`)

    if (!anchorElement) {
      return
    }

    const anchorRect = anchorElement.getBoundingClientRect()
    const popupWidth = 260
    const popupHeight = 248
    const viewportPadding = 12

    const nextTop = Math.min(
      Math.max(anchorRect.top - 12, viewportPadding),
      window.innerHeight - popupHeight - viewportPadding
    )

    const nextLeft = Math.min(
      Math.max(anchorRect.right + 12, viewportPadding),
      window.innerWidth - popupWidth - viewportPadding
    )

    setPopupPosition({
      top: nextTop,
      left: nextLeft,
    })
  }, [props.teachObj.TeacherID])

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        props.setOpenColorPicker(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef, props])

  return createPortal(
    <RadioGroup
      ref={modalRef}
      className="calendar-color-picker-popup"
      style={{ top: `${popupPosition.top}px`, left: `${popupPosition.left}px` }}
      value={selectedColor}
      onChange={(e) => props.changeTeacherColor(props.teach, e)}
    >
      <div className="calendar-color-picker-popup__eyebrow">Teacher Color</div>
      <RadioGroup.Label className="calendar-color-picker-popup__title">Choose a calendar color</RadioGroup.Label>
      <div className="calendar-color-picker-popup__grid">
        {colors.map((color) => (
          <RadioGroup.Option
            key={color.name}
            value={color}
            className={({ active, checked }) =>
              classNames(
                'calendar-color-picker-popup__color-option',
                color.selectedColor,
                active && checked ? 'ring ring-offset-1' : '',
                !active && checked ? 'ring-2' : ''
              )
            }
          >
            <RadioGroup.Label as="span" className="sr-only">
              {color.name}
            </RadioGroup.Label>
            <span
              aria-hidden="true"
              className={classNames(color.bgColor500, 'calendar-color-picker-popup__swatch')}
            />
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>,
    document.body
  )
}

export default ColorPickerPopupForCalendar;
